import get from 'lodash/get';
import { asmActions } from 'actions/saleActions';
import { PAGE_DATA_ACTIONS } from 'actions/pageActionsV4';
import { INIT, LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import { PRODUCT_DETAIL_SUCCESS, PRODUCT_DETAIL_REQUEST } from 'actions/productDetailsActions';
import { CHECKOUT_SUMMARY_REQUEST, CHECKOUT_SUMMARY_SUCCESS, CHECKOUT_SUMMARY_ERROR } from 'actions/CheckoutActions/checkoutSummaryActions';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import { CLPPages, pageTypes } from '../constants/pageTypes';
const defaultState = {
    asmData: null,
    index: 0,
    asyncStatus: INIT,
    popup: null,
    error: null
};
export function getPopupData(data) {
    return get(data, ['asmData', 'popup']) || get(data, ['popup']);
}
export function getASMData(data) {
    return (get(data, ['asmData', 'renderableComponents']) ||
        get(data, ['renderableComponents']));
}
export default function (state = defaultState, action) {
    switch (action.type) {
        case PAGE_DATA_ACTIONS.REQUEST:
            if (action.pageType === pageTypes.Product ||
                CLPPages.indexOf(action.pageType) !== -1) {
                return Object.assign({}, state, {
                    asyncStatus: LOADING,
                    error: null
                });
            }
            return state;
        case PRODUCT_DETAIL_REQUEST:
        case asmActions.REGISTER_FOR_SALE_REQUEST:
        case asmActions.JOIN_WAITLIST_REQUEST:
        case CHECKOUT_SUMMARY_REQUEST:
            return Object.assign({}, state, {
                asyncStatus: LOADING,
                error: null
            });
        case PRODUCT_DETAIL_SUCCESS:
            return Object.assign({}, state, {
                asyncStatus: SUCCESS,
                asmData: get(action.data, ['data', 'product_asm_default', 'data']),
                index: 0,
                popup: null
            });
        case PAGE_DATA_ACTIONS.SUCCESS:
            const pageSuccessAction = action;
            if (pageSuccessAction.pageType === pageTypes.Product ||
                CLPPages.indexOf(pageSuccessAction.pageType) !== -1) {
                const asmWidget = (get(action.data, 'slots') || []).find(slot => {
                    return get(slot, 'widget.type') === WidgetTypeV4.ASM;
                });
                const asmData = get(asmWidget, 'widget.data.renderableComponents', []);
                if (asmData && asmData.length > 0) {
                    return Object.assign({}, state, {
                        asyncStatus: SUCCESS,
                        asmData,
                        index: 0,
                        popup: null
                    });
                }
                return Object.assign({}, state, {
                    asyncStatus: INIT
                });
            }
            return state;
        case asmActions.ASM_NEXT_STATE:
            return Object.assign({}, state, {
                index: state.index + 1,
                popup: null
            });
        case asmActions.REGISTER_FOR_SALE_SUCCESS:
            return Object.assign({}, state, {
                asyncStatus: SUCCESS,
                asmData: getASMData(action.data),
                popup: getPopupData(action.data),
                index: 0
            });
        case asmActions.JOIN_WAITLIST_SUCCESS:
        case CHECKOUT_SUMMARY_SUCCESS:
            const waitlistSuccessAction = action;
            return Object.assign({}, state, {
                asyncStatus: SUCCESS,
                asmData: getASMData(waitlistSuccessAction.data),
                popup: getPopupData(waitlistSuccessAction.data),
                index: 0
            });
        case asmActions.REGISTER_FOR_SALE_ERROR:
        case asmActions.JOIN_WAITLIST_ERROR:
        case CHECKOUT_SUMMARY_ERROR:
            return Object.assign({}, state, {
                asyncStatus: ERROR,
                error: action.error
            });
        case asmActions.ASM_CLEAR_POPUP:
            return Object.assign({}, state, {
                popup: null
            });
        default:
            return state;
    }
}
